import axios from 'axios';
import { BASE_AGENT_WIDGETS_URL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

export const getCatalog = () =>
  axios.get(`${BASE_AGENT_WIDGETS_URL}/catalog`, authHeaders()).then((r) => r.data);

export const getTaskLayout = (taskId) =>
  axios.get(`${BASE_AGENT_WIDGETS_URL}/task/${taskId}/layout`, authHeaders()).then((r) => r.data);

export const saveTaskLayout = (taskId, layout) =>
  axios
    .put(`${BASE_AGENT_WIDGETS_URL}/task/${taskId}/layout`, { layout }, authHeaders())
    .then((r) => r.data);

export const saveTaskPrompt = (taskId, widgetKey, promptText) =>
  axios
    .put(
      `${BASE_AGENT_WIDGETS_URL}/task/${taskId}/prompts/${widgetKey}`,
      { prompt_text: promptText },
      authHeaders(),
    )
    .then((r) => r.data);

export const setTaskOverviewEnabled = (taskId, isEnabled) =>
  axios
    .put(
      `${BASE_AGENT_WIDGETS_URL}/task/${taskId}/overview-enabled`,
      { is_enabled: isEnabled },
      authHeaders(),
    )
    .then((r) => r.data);

export const setTaskShowProjectDetail = (taskId, show) =>
  axios
    .put(
      `${BASE_AGENT_WIDGETS_URL}/task/${taskId}/show-project-detail`,
      { show },
      authHeaders(),
    )
    .then((r) => r.data);

export const setTaskShowFilesTab = (taskId, show) =>
  axios
    .put(
      `${BASE_AGENT_WIDGETS_URL}/task/${taskId}/show-files-tab`,
      { show },
      authHeaders(),
    )
    .then((r) => r.data);

export const setTaskAllowLocalFiles = (taskId, allow) =>
  axios
    .put(
      `${BASE_AGENT_WIDGETS_URL}/task/${taskId}/allow-local-files`,
      { allow },
      authHeaders(),
    )
    .then((r) => r.data);
